import { urls } from '../../../../constants/constants';

export const getUsers = (userId, tab, offset, search) => {
  return new Promise((resolve, reject) => {
    fetch(
      `${
        urls.aspariaBackend
      }api/v1/livechat-agent/getClients?active=${tab}&pageNo=${offset}&pageSize=15&search=${search}`,
      {
        headers: {
          method: 'GET',
          accept: 'application/json',
          Authorization: `Bearer `,
        },
        credentials: 'include',
      }
    )
      .then((data) => {
        return data.json();
      })
      .then((result) => {
        resolve(result);
      })
      .catch((err) => {
        reject(err);
      });
  });
};
